module.exports = __webpack_public_path__ + "img/down.f6409ce9.svg";